/* eslint-disable react/no-array-index-key */
import { useState , useEffect } from 'react'
import InputRange from 'newComponents/Forms/InputRange'
import styles from './styles.module.sass'


const Range = (props) => {
    const {
        rangePrice,
        resetFilters,
        setListRangePrice
    } = props


    const [ activeRangePrice, setActiveRangePrice ] = useState({})
    const [ min, setMin ] = useState()
    const [ max, setMax ] = useState()
    const [ range, setRange ] = useState()
    
    const handleMin = (event) => {
        const valorMin = event.target.value
        // console.log('valorMin: ',valorMin)
        setMin( Number(valorMin) )
    }
    const handleMax = (event) => {
        const valorMax = event.target.value
        // console.log('valorMax: ',valorMax)
        setMax( Number(valorMax) )
    }

    const handleClick = () => {
        setActiveRangePrice( {
            max: range?.to,
            min: range?.from
        } )
    }
    
    
    useEffect(()=>{
        if(rangePrice){
            setMin( Number(rangePrice?.min) )
            setMax( Number(rangePrice?.max) )
            setRange({
                from: Number(rangePrice?.min), to: Number(rangePrice?.max) 
            })
        }
    },[rangePrice])

    useEffect(()=>{
        if(range){
            // console.log('range: ',range)
        }
    },[range])

    useEffect(()=>{
        if(activeRangePrice){
            setListRangePrice(activeRangePrice)
        }
    },[activeRangePrice])

    useEffect(()=>{
        if(resetFilters){
            setActiveRangePrice({})
        }
    },[resetFilters])


    return(
        <>
            <div className={styles?.seccionPrecio}>
                <div className={styles?.texto}>
                    <p className={styles?.h2}>Precio</p>
                </div>
                {range
                    ?
                        <div className={styles?.sliderPrecioDesk}>
                            <InputRange
                                minValue={min}
                                maxValue={max}
                                value={[range?.from, range?.to]}
                                onChange={setRange}
                            />
                        </div>
                    : null
                }

                {range
                    ?
                        <div className={styles?.precios}>
                            <label className={styles?.labelPrice} htmlFor="priceMin" >$
                                <input type="number" id="priceMin" placeholder={`Min $${ rangePrice?.min?.toLocaleString('en-US')}`} value={range?.from} onChange={handleMin} pattern="[0-9]{0,13}" />
                            </label>

                            <label className={styles?.labelPrice} htmlFor="priceMax">$
                                <input type="number" id="priceMax" placeholder={`Max $${ rangePrice?.max?.toLocaleString('en-US')}`} value={range?.to} onChange={handleMax} pattern="[0-9]{0,13}" />
                            </label>
                        </div>
                    : null
                }
                
                <div className="botonFiltrarDes">
                    <div className="btn primaryButton btn-block" onClick={handleClick} aria-hidden>Aplicar filtros</div>
                </div>
            </div>
        </>
    )
}

export default Range